exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-result-header-tools {\n    width: 160px;\n    float: right;\n    font-size: 0;\n    white-space: nowrap;\n    text-align: right;\n}\n.search-result-header-tools li i {\n    cursor: pointer;\n}\n.search-result-header-tools li {\n    display: inline-block;\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n    text-align: right;\n    line-height: 40px;\n}\n.search-result-header-tools li i:hover {\n    color: rgba(255,50,50,1.0);\n}\n", ""]);

// exports
